import React from 'react'
import { StyledButton } from './styled'

const Button = (props) => {
    return(
        <StyledButton disabled={props.disabled ? props.disabled : false} width={props.width} fontSize={props.fontSize} onClick={props.onClick} color={props?.color ? props?.color : 'primary'} className='btn'>
            {
                props.label
                ? props.label
                : props.children
            }
        </StyledButton>
    )
}

export default Button